/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ requestId: NonNullable<unknown> }} Order_Detail_Forbidden_With_Request_IdInputs */

const vi_order_detail_forbidden_with_request_id = /** @type {(inputs: Order_Detail_Forbidden_With_Request_IdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem đơn này — Mã: ${i?.requestId}`)
};

/**

* @param {Order_Detail_Forbidden_With_Request_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_detail_forbidden_with_request_id = /** @type {((inputs: Order_Detail_Forbidden_With_Request_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Detail_Forbidden_With_Request_IdInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_detail_forbidden_with_request_id(inputs)
});